import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgGreenDollarBig = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={58}
    height={47}
    fill="none"
    viewBox="0 0 28 17"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M13.682 13.357h.922v-.971a2.695 2.695 0 0 0 1.512-.698c.413-.385.62-.88.62-1.488 0-.526-.212-.966-.636-1.32a5.444 5.444 0 0 0-1.464-.866V5.768c.213.06.388.162.525.303.138.142.239.314.303.517l1.145-.456a2.027 2.027 0 0 0-.764-1.017 3.02 3.02 0 0 0-1.209-.5v-.972h-.954v.94c-.594.062-1.098.27-1.511.623-.414.354-.621.825-.621 1.412 0 .546.217 1.002.652 1.366a5.48 5.48 0 0 0 1.48.88v2.398a1.934 1.934 0 0 1-1.337-1.366l-1.113.456c.17.566.466 1.032.89 1.396.425.365.945.587 1.56.668v.941Zm.954-2.125V9.23c.234.1.44.222.62.364.181.142.271.354.271.637 0 .324-.085.552-.254.683-.17.132-.382.238-.637.32Zm-.954-3.612a3.199 3.199 0 0 1-.636-.365c-.191-.141-.287-.354-.287-.637 0-.283.095-.49.287-.622.19-.132.402-.218.636-.259V7.62ZM8.909 17c-2.482 0-4.587-.825-6.316-2.474C.864 12.876 0 10.868 0 8.5s.864-4.376 2.593-6.026C4.322.824 6.427 0 8.91 0h10.182c2.482 0 4.587.825 6.316 2.474C27.136 4.124 28 6.132 28 8.5s-.864 4.377-2.593 6.026C23.678 16.176 21.573 17 19.09 17H8.909Zm0-2.429h10.182c1.76 0 3.261-.591 4.502-1.775 1.241-1.184 1.861-2.616 1.861-4.296 0-1.68-.62-3.112-1.86-4.296-1.242-1.183-2.742-1.775-4.503-1.775H8.909c-1.76 0-3.261.592-4.502 1.775C3.166 5.388 2.545 6.82 2.545 8.5c0 1.68.62 3.112 1.862 4.296 1.24 1.184 2.741 1.775 4.502 1.775Z"
      fill="#00BC82"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGreenDollarBig);
export default ForwardRef;
